import { globalStores } from '@/editor/stores';
import AssemblyEntity from '@/editor/entities/assemblyEntity';
import { EEntityType } from '@/editor/types';

export class AssemblyManager {
  private _list: AssemblyEntity[] = [];

  getEntity(entityId: string) {
    return this._list.find((entity) => entity.id === entityId);
  }

  private deleteAssemblyEntity(index: number) {
    if (index >= this._list.length || index < 0) return;
    this._list[index].dispose();
    this._list.splice(index, 1);
  }

  private addAssemblyEntity(entity: AssemblyEntity) {
    this._list.push(entity);
  }

  private _getEffectiveAssemblyList() {
    const assemblyHiddenIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(EEntityType.Assembly);
    return globalStores.assemblyStore.getAssemblyDatas().filter((data) => !assemblyHiddenIds.has(data.id));
  }

  update() {
    const assemblyDatas = this._getEffectiveAssemblyList();
    const newAssemblyDataMap = new Map(assemblyDatas.map((data) => [data.id, data]));

    for (let i = this._list.length - 1; i >= 0; i--) {
      const entity = this._list[i];
      const data = newAssemblyDataMap.get(entity.id);
      if (!data) {
        this.deleteAssemblyEntity(i);
      } else {
        entity.update(data);
      }

      newAssemblyDataMap.delete(entity.id);
    }

    for (const data of newAssemblyDataMap.values()) {
      const assemblyEntity = new AssemblyEntity({ id: data.id });
      this.addAssemblyEntity(assemblyEntity);
      assemblyEntity.update(data);
    }
  }

  updateAssembly({ id }: { id: string }) {
    const data = globalStores.assemblyStore.getAssemblyData(id);
    let assemblyEntity = this.getEntity(id);
    if (!data) {
      if (assemblyEntity) this.deleteAssemblyEntity(this._list.indexOf(assemblyEntity));
      return;
    }

    if (!assemblyEntity) {
      assemblyEntity = new AssemblyEntity({ id: data.id });
      this.addAssemblyEntity(assemblyEntity);
    }

    assemblyEntity.update(data);
  }
}
